import { render, staticRenderFns } from "./TeklifOnayiMesajOnay.vue?vue&type=template&id=71e52b58&"
import script from "./TeklifOnayiMesajOnay.vue?vue&type=script&lang=js&"
export * from "./TeklifOnayiMesajOnay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports